/** Done, current and upcoming steps (by the sign of step − current, plus one). */
const TONE = ["text-zinc-700", "font-medium text-blue-700", "text-zinc-400"] as const;

/** Where a wizard is: its steps numbered, the `current` one (0-based) highlighted, earlier ones done. */
export function Steps({ labels, current }: { labels: readonly string[]; current: number }) {
  return (
    <ol class="mb-6 flex flex-wrap gap-x-6 gap-y-2 text-sm">
      {labels.map((label, i) => (
        <li
          key={label}
          class={`flex items-center gap-2 ${TONE[Math.sign(i - current) + 1]}`}
          aria-current={i === current ? "step" : undefined}
        >
          <span class="flex size-6 items-center justify-center rounded-full border border-current text-xs">
            {i + 1}
          </span>
          {label}
        </li>
      ))}
    </ol>
  );
}
